!<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <vs-button
        radius
        @click.stop="back()"
        class="float-left mr-2"
        type="border"
        icon-pack="feather"
        icon="icon-arrow-left"
      ></vs-button>

      <span class="font">{{ users.title }}</span>
    </div>
    <!-- <div class="ml-auto md:block">
            <vs-button color="danger" icon-pack="feather">Deactivate</vs-button>
        </div> -->
    <vx-card class="mt-4">
      <vs-tabs vs-alignment="fixed">
        <vs-tab :label="$t('labels.e_details')">
          <vs-row vs-w="12">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-avatar class="mx-auto" size="100px" :src="users.image" />
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <h2>{{ users.title }}</h2>
              <p>{{ users.location.city }}, {{ users.location.zipcode }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-divider></vs-divider>
          <vs-row vs-w="12" class="mb-3">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.hostedby") }}</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.name }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-3">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.Category") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.code }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-3">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.description") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.description }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-3">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.event_date") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.date }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-3">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.event_time") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.starting_time }} - {{ users.ending_time }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
        </vs-tab>
        <vs-tab :label="$t('labels.attendees')">
          <vs-table max-items="10" stripe :data="bookers">
            <template slot="thead">
              <vs-th>{{ $t("labels.profile_pic") }}</vs-th>
              <vs-th>{{ $t("labels.name") }}</vs-th>
              <vs-th>{{ $t("labels.email") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].profile_pic">
                  <vs-avatar
                    class="mx-auto"
                    size="100px"
                    :src="data[indextr].user_detail.profile_pic"
                  />
                </vs-td>

                <vs-td :data="data[indextr].name">
                  {{ data[indextr].user_detail.name }}
                </vs-td>

                <vs-td :data="data[indextr].email">
                  {{ data[indextr].user_detail.email }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    users: [],
    bookers: [],
    reports: [],
    apple: 0,
    facebook: 0,
    google: 0,
    routing: "",
    page: null,
  }),
  methods: {
    getClassDetails() {
      axios
        .get("event/getEventsById/" + this.$route.params.id)
        .then((response) => {
          // let data = response.data.data;
          this.users = response.data.data;
          if (this.users.mode == "ON") {
            this.routing = "Online_Events";
          } else {
            this.routing = "Offline_Events";
          }
          console.log(this.users);
        })
        .catch((err) => console.log(err.response));
    },
    getUserDetails() {
      axios
        .get("event/attendingListing/" + this.$route.params.id)
        .then((response) => {
          // let data = response.data.data;
          this.bookers = response.data.data;
          console.log(this.bookers);
        })
        .catch((err) => console.log(err.response));
    },
    back() {
      if (this.page) {
        this.$router.push({ name: this.routing, query: { page: this.page } });
        // this.$router.push({name: "Students",params:{page:this.page}});
      } else {
        history.back();
      }
    },
  },
  mounted() {
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    this.getClassDetails();
    this.getUserDetails();
  },
};
</script>

<style lang="scss" scoped>
</style>